import { useModalVerify } from '@droplet-tech-code/core-elements/module/ui/Modal';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { handleResponse } from '@droplet-tech-code/core-elements/module/utils/error';
import { SupportRequestBackendClient } from '@naus-code/naus-admin-types';
import { LinkText } from '~/components/LinkText';
import { useGetAuthUserRole } from '~/screens/Auth/Auth.Context';
import { bookingApi } from '~/screens/Support/Bookings/Bookings.api';
import { supportRequestActionsApi } from '~/screens/Support/Requests/supportRequestActions.api';
import { translate } from '~/utils/translation.utils';

export const KoalaRequestOption = ({
  supportRequestInfo,
  check,
}: {
  supportRequestInfo: SupportRequestBackendClient;
  check: string;
}) => {
  const { verifyAction } = useModalVerify();
  const { bookingId } = supportRequestInfo;
  const { data } = bookingApi.useGetBookingQuery(bookingId || '', {
    skip: !bookingId,
  });
  const userRole = useGetAuthUserRole();
  const canSeeVoidKoala =
    userRole === 'ADMIN' || userRole === 'CUSTOMER_SUPPORT_LEAD' || userRole === 'SYSTEM';
  const [claimKoala, { isLoading: isClaiming }] =
    supportRequestActionsApi.useClaimKoalaMutation();
  const [voidKoala, { isLoading: isVoiding }] =
    supportRequestActionsApi.useVoidKoalaMutation();

  if (!data?.booking || !bookingId) {
    return null;
  }

  if (!data.booking.bookingKoala || data.booking.bookingKoala.status !== 'UNUSED') {
    return null;
  }

  return (
    <VStack space="2.5" p="3">
      <VStack
        flex={1}
        space="2"
        align="center"
        bg="primary-extraLight"
        p="2.5"
        b={1}
        bc="primary-light"
        br={8}
      >
        <LinkText
          textStyle={{ fontSize: 15, color: '#4565a1ff' }}
          isLoading={isClaiming}
          onPress={async () => {
            verifyAction({
              title: translate('supportRequests.requestOptions.koala.modalTitle'),
              description: translate(
                'supportRequests.requestOptions.koala.modalDescription',
              ),
            }).then(async (verify) => {
              if (!verify) {
                return;
              }
              await claimKoala({
                supportId: supportRequestInfo._id,
                check,
                bookingId,
              }).then((response) => handleResponse({ response }));
            });
          }}
        >
          {translate('supportRequests.requestOptions.koala.claimKoala')}
        </LinkText>
      </VStack>
      {canSeeVoidKoala && (
        <VStack
          flex={1}
          space="2"
          align="center"
          bg="error-extraLight"
          p="2.5"
          b={1}
          bc="error-light"
          br={8}
        >
          <LinkText
            textStyle={{ fontSize: 15, color: 'rgb(208, 44, 44)' }}
            isLoading={isVoiding}
            onPress={async () => {
              verifyAction({
                title: translate('supportRequests.requestOptions.koala.modalTitleVoid'),
                description: translate(
                  'supportRequests.requestOptions.koala.modalDescription',
                ),
              }).then(async (verify) => {
                if (!verify) {
                  return;
                }
                await voidKoala({
                  supportId: supportRequestInfo._id,
                  check,
                  bookingId,
                }).then((response) => handleResponse({ response }));
              });
            }}
          >
            {translate('supportRequests.requestOptions.koala.voidKoala')}
          </LinkText>
        </VStack>
      )}
    </VStack>
  );
};
